import { render, staticRenderFns } from "./card-stack-carousel-item.vue?vue&type=template&id=6a5991f3&scoped=true"
import script from "./card-stack-carousel-item.vue?vue&type=script&lang=js"
export * from "./card-stack-carousel-item.vue?vue&type=script&lang=js"
import style0 from "./card-stack-carousel-item.vue?vue&type=style&index=0&id=6a5991f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5991f3",
  null
  
)

export default component.exports